

import React from 'react';

const RefreshIcon = ({ width = 15, height = 15, color = "#18181B" }) => (
    <svg width={width} height={height} viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.1608 18.3747C17.2822 16.8292 18.6608 14.3256 18.6608 11.5001C18.6608 6.80568 14.8552 3.0001 10.1608 3.0001H9.66083M10.1608 20.0001C5.46641 20.0001 1.66083 16.1945 1.66083 11.5001C1.66083 8.67456 3.03949 6.17103 5.16083 4.6255M9.16083 21.9001L11.1608 19.9001L9.16083 17.9001M11.1608 5.1001L9.16083 3.1001L11.1608 1.1001" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default RefreshIcon;